module.exports = __webpack_public_path__ + "img/card-b7.085d4471.png";